import { render, staticRenderFns } from "./audit-item-details.component.vue?vue&type=template&id=0888486c&scoped=true"
import script from "./audit-item-details.component.vue?vue&type=script&lang=ts"
export * from "./audit-item-details.component.vue?vue&type=script&lang=ts"
import style0 from "./audit-item-details.component.vue?vue&type=style&index=0&id=0888486c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0888486c",
  null
  
)

export default component.exports